/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  daysToMonths
 */

export function daysToMonths(days: number): number
export function daysToMonths(days: null): null
export function daysToMonths(days: undefined): undefined
export function daysToMonths(days: number | null | undefined): number | null | undefined
export function daysToMonths(days: number | null | undefined): number | null | undefined {
  return days == null ? days : Math.round(days / 30)
}
